import { CustomerVisitHistoryPanel } from '@/components/masters/CustomerVisitHistoryPanel'

/**
 * Visit history tab for the customer edit modal (Masters).
 *
 * @param {{ customerId: number | null }} props
 */
export function CustomerVisitHistoryTab({ customerId }) {
  return <CustomerVisitHistoryPanel customerId={customerId} variant="masters" visitLimit={50} />
}
